"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InfiniteLoaderDesktop_1 = require("./InfiniteLoaderDesktop");
exports.default = InfiniteLoaderDesktop_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/InfiniteLoader/InfiniteLoaderDesktop/index.js
// module id = 335
// module chunks = 8